import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b817809a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b817809a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b817809a')) {
      api.createRecord('b817809a', component.options)
    } else {
      api.reload('b817809a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b817809a&scoped=true&", function () {
      api.rerender('b817809a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2clHv9Pe0YCnE/JS/comp/SearchFilterTokens.vue"
export default component.exports